module.exports = __webpack_public_path__ + "img/03-1.d4f7918d.png";